import { useLocation } from 'react-router';

import { catchAll } from '@sorare/routing';

import { Rarity } from '#src/__generated__/globalTypes.ts';
import {
  ANY_SPORT_ESSENCE,
  ANY_SPORT_MARKET,
  ANY_SPORT_MY_CARDS,
  ANY_SPORT_MY_CARDS_CARDS_TYPE,
  ANY_SPORT_MY_CARDS_REVEALABLE_CARDS,
  ANY_SPORT_PLAY,
  ANY_SPORT_SCOUTING_CENTER,
  ANY_SPORT_SERIES_MARKET_COMMON_PACKS,
} from '#src/constants/__generated__/routes.ts';
import { useSportContext } from '#src/contexts/sport/index.ts';
import { useSeriesNav } from '#src/hooks/commonGame/useSeriesNav.ts';
import { matchAnySportPath } from '#src/lib/routing/generateSportPath.ts';

import { InGameCurrencyAgreggated } from './useUserCurrencies.tsx';

export const useExpandedCurrencies = () => {
  const { pathname } = useLocation();

  const seriesNav = useSeriesNav();

  const { generateSportContextPath } = useSportContext();
  if (!pathname) {
    return [];
  }

  const isPlay = !!matchAnySportPath(catchAll(ANY_SPORT_PLAY), pathname);
  const isScoutingCenter = !!matchAnySportPath(
    catchAll(ANY_SPORT_SCOUTING_CENTER),
    pathname
  );
  const isMarket = !!matchAnySportPath(catchAll(ANY_SPORT_MARKET), pathname);
  const isMyCards = !!matchAnySportPath(catchAll(ANY_SPORT_MY_CARDS), pathname);

  const isCommonMarket = !!matchAnySportPath(
    catchAll(generateSportContextPath(ANY_SPORT_SERIES_MARKET_COMMON_PACKS)),
    pathname
  );
  const isCommonMyCards = !!matchAnySportPath(
    catchAll(
      generateSportContextPath(ANY_SPORT_MY_CARDS_CARDS_TYPE, {
        params: {
          type: Rarity.common,
        },
      })
    ),
    pathname
  );

  /* From more specific condition to more generalist one */
  if (seriesNav) {
    return [InGameCurrencyAgreggated.SHARDS, InGameCurrencyAgreggated.GEMS];
  }

  if (isCommonMyCards) {
    return [InGameCurrencyAgreggated.XP, InGameCurrencyAgreggated.SHARDS];
  }
  if (isCommonMarket) {
    return [InGameCurrencyAgreggated.GEMS, InGameCurrencyAgreggated.SHARDS];
  }
  if (matchAnySportPath(catchAll(ANY_SPORT_ESSENCE), pathname)) {
    return [InGameCurrencyAgreggated.SHARDS];
  }
  if (
    matchAnySportPath(catchAll(ANY_SPORT_MY_CARDS_REVEALABLE_CARDS), pathname)
  ) {
    return [InGameCurrencyAgreggated.BLUEPRINTS];
  }
  if (isMyCards) {
    return [InGameCurrencyAgreggated.XP, InGameCurrencyAgreggated.ENERGY];
  }
  if (isPlay || isScoutingCenter || isMarket) {
    return [InGameCurrencyAgreggated.SHARDS];
  }

  /* Other routes */
  return [InGameCurrencyAgreggated.SHARDS];
};
